let AuthedUserSession = require("./AuthedUserSession");

module.exports = function(event){
	return event && event.accountinglocked && !AuthedUserSession.doIHaveAccess.admin.any(event.sids);
};



// WEBPACK FOOTER //
// ./src/utils/isEventAccountingLockedForMe.js